import { render, staticRenderFns } from "./ReviewPay.vue?vue&type=template&id=3cadfa81&scoped=true"
import script from "./ReviewPay.vue?vue&type=script&lang=js"
export * from "./ReviewPay.vue?vue&type=script&lang=js"
import style0 from "./ReviewPay.vue?vue&type=style&index=0&id=3cadfa81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cadfa81",
  null
  
)

export default component.exports